import React, { useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";
import DateRangeFilter from "../../../components/shared/fields/DateRangeFilter";
import DashboardSection from "../../dashboard/components/DashboardSection";
import "../../dashboard/components/dashboard-sections.css";
import { PackageIconSvg } from "../../../svgFiles/PackageIconSvg";
import { CycleIconSvg } from "../../../svgFiles/CycleIconSvg";
import { ScaleIconSvg } from "../../../svgFiles/ScaleIconSvg";
import { TrendingUpIconSvg } from "../../../svgFiles/TrendingUpIconSvg";
import { Invoice } from "../../../svgFiles/Invoice";
import { GreenTickSvg } from "../../../svgFiles/GreenTickSvg";
import { ReceiptSvg } from "../../../svgFiles/ReceiptSvg";
import { AlertSvg } from "../../../svgFiles/AlertSvg";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ExpenseDashboard = () => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);

  const handleApplyRange = ({ startDate, endDate }) => {
    // Handle date range updates
  };

  // ── Overview Metric Cards ────────────────────────────────────
  const overviewMetrics = [
    { label: _t("total_expenses", "Total Expenses"), value: 0, unit: "", color: "#3b82f6", bgColor: "#eff6ff" },
    { label: _t("amount_paid", "Amount Paid"), value: 0, unit: "", color: "#10b981", bgColor: "#ecfdf5" },
    { label: _t("outstanding_pending", "Outstanding / Pending"), value: 0, unit: "", color: "#f59e0b", bgColor: "#fffbeb" },
    { label: _t("overdue_amount", "Overdue Amount"), value: 0, unit: "", color: "#ef4444", bgColor: "#fef2f2" },
  ];

  // ── Status Breakdown Items ───────────────────────────────────
  const statusBreakdownItems = [
    { label: _t("paid", "Paid"), value: 0, unit: "", color: "#10b981" },
    { label: _t("pending", "Pending"), value: 0, unit: "", color: "#f59e0b" },
    { label: _t("overdue", "Overdue"), value: 0, unit: "", color: "#ef4444" },
    { label: _t("draft", "Draft"), value: 0, unit: "", color: "#6b7280" },
  ];

  // ── Top Vendors Items ────────────────────────────────────────
  const topVendorsItems = [
    { label: _t("vendor_1", "Vendor A"), value: 0, percentage: 0 },
    { label: _t("vendor_2", "Vendor B"), value: 0, percentage: 0 },
    { label: _t("vendor_3", "Vendor C"), value: 0, percentage: 0 },
    { label: _t("vendor_4", "Vendor D"), value: 0, percentage: 0 },
    { label: _t("vendor_5", "Vendor E"), value: 0, percentage: 0 },
  ];

  // ── Monthly Spend Trend ──────────────────────────────────────
  const monthlySpendData = [
    { month: "Jan", value: 10 },
    { month: "Feb", value: 15 },
    { month: "Mar", value: 14 },
    { month: "Apr", value: 15 },
    { month: "May", value: 20 },
    { month: "Jun", value: 30 },
    { month: "Jul", value: 25 },
    { month: "Aug", value: 18 },
    { month: "Sep", value: 22 },
    { month: "Oct", value: 27 },
    { month: "Nov", value: 30 },
    { month: "Dec", value: 40 },
  ];

  // ── Document Coverage Items ──────────────────────────────────
  const documentCoverageItems = [
    { label: _t("invoices_attached", "Invoices Attached"), value: 0, icon: Invoice, color: "#d95140" },
    { label: _t("receipts_attached", "Receipts Attached"), value: 0, icon: ReceiptSvg, color: "#3b82f6" },
    { label: _t("missing_invoice", "Missing Invoice"), value: 0, icon: AlertSvg, color: "#ef4444" },
    { label: _t("registered_bills", "Registered Bills"), value: 0, icon: GreenTickSvg, color: "#10b981" },
  ];

  return (
    <div>
      {/* ── Toolbar with Date Filter ──────────────────────────── */}
      <div className="receiving_dashboard_toolbar align-items-center">
        <div>
        <h5 className="receiving_dashboard_toolbar_title m-0">
          {_t("bills_and_exppense_overview", "Bills & Expense Overview")}
        </h5>        
        </div>
        <div className="receiving_filter_group">
          <DateRangeFilter
            setDate={setDate}
            onApplyRange={handleApplyRange}
            triggerId="expense-date-range-filter"
          />
        </div>
      </div>

      {/* ── Expense Summary Section ──────────────────────────────── */}
      <DashboardSection title={_t("expense_summary", "Expense Summary")}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px"}}>
          {overviewMetrics.map((metric, i) => (
            <div
              key={i}
              style={{
                backgroundColor: "#f9fafb",
                border: "1px solid #f0f1f3",
                borderRadius: "8px",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div style={{ fontSize: "11px", fontWeight: "600", color: "#667085", textTransform: "uppercase" }}>
                {metric.label}
              </div>
              <div style={{ fontSize: "20px", fontWeight: "700", color: metric.color }}>
                ${metric.value}
              </div>
            </div>
          ))}
        </div>
      </DashboardSection>

      {/* ── Status Breakdown - Document Coverage - Top Vendors ──────────────────────── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", marginBottom: "24px" }}>
        {/* Status Breakdown */}
        {/* <DashboardSection title={_t("status_breakdown", "Status Breakdown")}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "0 16px" }}>
            {statusBreakdownItems.map((item, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "12px", borderBottom: i < statusBreakdownItems.length - 1 ? "1px solid #f0f1f3" : "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: item.color,
                    }}
                  />
                  <span style={{ fontSize: "13px", color: "#1d1f2c", fontWeight: "500" }}>{item.label}</span>
                </div>
                <span style={{ fontSize: "14px", fontWeight: "600", color: "#1d1f2c" }}>
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        </DashboardSection> */}

        {/* Document Coverage */}
        {/* <DashboardSection title={_t("document_coverage", "Document Coverage")}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "10px", padding: "0 16px" }}>
            {documentCoverageItems.map((item, i) => (
              <div
                key={i}
                style={{
                  backgroundColor: "#f9fafb",
                  border: "1px solid #f0f1f3",
                  borderRadius: "6px",
                  padding: "12px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <div style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {item.icon}
                </div>
                <div style={{ fontSize: "14px", fontWeight: "700", color: item.color }}>
                  {item.value}
                </div>
                <div style={{ fontSize: "10px", fontWeight: "600", color: "#667085", textAlign: "center" }}>
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </DashboardSection> */}

        {/* Top Vendors */}
        <DashboardSection title={_t("top_vendors_by_spend", "Top Vendors by Spend")}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "0 16px" }}>
            {topVendorsItems.map((vendor, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "12px", borderBottom: i < topVendorsItems.length - 1 ? "1px solid #f0f1f3" : "none" }}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: "600", color: "#1d1f2c" }}>
                    {vendor.label}
                  </div>
                  <div style={{ fontSize: "11px", color: "#667085" }}>
                    {vendor.percentage}% of expenses
                  </div>
                </div>
                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1d1f2c" }}>
                  ${vendor.value}
                </div>
              </div>
            ))}
          </div>
        </DashboardSection>
      </div>

      {/* ── Monthly Spend Trend ──────────────────────────────────── */}
      <DashboardSection
        title={
          <span className="d-flex align-items-center gap-2">
            <TrendingUpIconSvg size={18} color="#fb923c" />
            {_t("monthly_spend_trend", "Monthly Spend Trend")}
          </span>
        }
      >
        <div className="cmn_card">
          <div className="p-2">
            {/* Chart Header with Peak Month, Avg, and Date Range */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", backgroundColor: "#f9fafb", border: "1px solid #f0f1f3", borderRadius: "8px", marginBottom: "12px" }}>
              <div>
                <div style={{ fontSize: "11px", fontWeight: "600", color: "#667085", textTransform: "uppercase" }}>
                  {_t("peak_month", "Peak Month")}
                </div>
                <div style={{ fontSize: "15px", fontWeight: "700", color: "#fb923c", marginTop: "2px" }}>
                  May • $58,400
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "11px", fontWeight: "600", textTransform: "uppercase", color: "#667085" }}>
                  {(() => {
                    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
                    const currentMonth = months[new Date().getMonth()];
                    const nextMonth = months[(new Date().getMonth() + 1) % 12];
                    const year = new Date().getFullYear();
                    return `JAN - ${nextMonth} ${year}`;
                  })()}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "11px", fontWeight: "600", textTransform: "uppercase", color: "#667085" }}>
                  {_t("six_month_avg", "6-Month Avg")}
                </div>
                <div style={{ fontSize: "15px", fontWeight: "700", color: "#1d1f2c", marginTop: "2px" }}>
                  $47,417
                </div>
              </div>
            </div>
            <HighchartsReact
              highcharts={Highcharts}
              options={{
                chart: { type: "column" },
                title: { text: null },
                xAxis: {
                  categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                  labels: { style: { fontSize: "12px", color: "#8C97A7" } },
                },
                yAxis: { title: { text: _t("amount", "Amount") } },
                legend: { enabled: false },
                tooltip: { shared: true },
                plotOptions: {
                  column: {
                    borderWidth: 0,
                    dataLabels: { enabled: false },
                  },
                },
                series: [
                  {
                    name: _t("monthly_expenses", "Monthly Expenses"),
                    data: monthlySpendData.map((item) => item.value),
                    color: "#fb923c",
                  },
                ],
              }}
            />
          </div>
        </div>
      </DashboardSection>
    </div>
  );
};

export default ExpenseDashboard;
